import React from 'react';

export default function PromoteBusiness() {
  return <div>PromoteBusiness</div>;
}
